import { INewbuildingConsultant } from '../../types/newbuildingConsultant';
import { ENBConsutantActions, TNewbuildingConsultantActions } from '../../actions/newbuildingConsultant';

export const defaultState: INewbuildingConsultant = {
  accountName: '',
  chatOpen: false,
  chatNeedForceOpen: false,
  showMotivationPopup: false,
  consultantPopupOpen: false,
};

export function newbuildingConsultant(
  state: INewbuildingConsultant = defaultState,
  action: TNewbuildingConsultantActions,
) {
  switch (action.type) {
    case ENBConsutantActions.OpenChat:
      return {
        ...state,
        chatOpen: action.payload,
        showMotivationPopup: false,
      };
    case ENBConsutantActions.ShowMotivationPopup:
      return {
        ...state,
        showMotivationPopup: action.payload,
      };
    case ENBConsutantActions.OpenConsultantPopup:
      return {
        ...state,
        consultantPopupOpen: action.payload,
      };
    default:
      return state;
  }
}
